import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { blogRoute } from '.'

const BlogDetails = lazyRouteComponent(() => import('../../pages/blogs/blog-details'))

export const blogDetailsRoute = createRoute({
  getParentRoute: () => blogRoute,
  path: '$',
  component: BlogDetails,
})
